import { AuthService } from 'src/app/Service/AuthService';

import { BasePanelController } from '../../../../../BaseUI/BasePanelController';
import { PasswordResettingPanelComponent } from './PasswordResettingPanelComponent';


/**
 * PasswordResettingPanelController
 * パスワード変更パネルのコントローラー
 */
export class PasswordResettingPanelController extends BasePanelController {

	// 対となるView
	public combineView: PasswordResettingPanelComponent;


	/**
	 * resetPassword
	 * パスワードの変更を行う
	 * @param param view: 現在画面、oldPass: 現在のパスワード、newPass: 新しいパスワード
	 * @returns ユーザー情報
	 */
	public async resetPassword(param: { view: any; oldPass: string; newPass: string }) {

		const svc = new AuthService(param.view);
		const ret = await svc.changeUserPassword(param.oldPass, param.newPass);

		return ret;

	}

}
